import { z } from 'zod';

export const DbClassicPinTypeSchema = z.enum([
  'slide',
  'question',
  'openQuestion',
  'wordweb',
  'video',
  'poll',
  'map',
  'dragQuestion',
  'link',
]);

export type DbClassicPin = z.infer<typeof DbClassicPinTypeSchema>;
